import React from "react";
import moment from "moment";
import { Table, Space } from "antd";
import { Link } from "react-router-dom";
import {
  CloudDownloadOutlined,
  FileTextOutlined,
  ContainerTwoTone,
} from "@ant-design/icons";
import { formatCurrency, invoiceStatus } from "../../utils/format";

const columns = [
  {
    title: "",
    render: (e) => {
      if (e.paymentStatus === "not_paid") {
        return <ContainerTwoTone twoToneColor="#FFAA00" />;
      } else if (e.paymentStatus === "paid") {
        return <ContainerTwoTone twoToneColor="#52C41A" />;
      } else if (e.paymentStatus === "pending") {
        return <ContainerTwoTone twoToneColor="#4BBEDA" />;
      }
    },
    align: "center",
  },
  {
    title: "НЭХЭМЖЛЭХ №",
    dataIndex: "code",
    align: "center",
    render: (text, record) => {
      return (
        <Link to={{
          pathname: `/invoice-desc/${record?._id}`,
          state: {
            id: record._id,
          },
        }}>
          <p>{record?.code}</p>
        </Link>
        
      )
    }
  },
  {
    title: "МЕРЧАНТ КОД",
    dataIndex: "relatedCode",
    align: "center",
  },
  {
    title: "НЭХЭМЖИЛСЭН ОГНОО",
    dataIndex: "invoiceDate",
    render: (e) => {
      return moment(e).format("L");
    },
    align: "center",
  },
  {
    title: "ТӨЛӨХ ХУГАЦАА",
    dataIndex: "dueDate",
    render: (e) => {
      return moment(e).format("L");
    },
    align: "center",
  },
  {
    title: "НИЙТ ДҮН (НӨАТ-тай)",
    dataIndex: "amount",
    sorter: {
      compare: (a, b) => a.amount - b.amount,
      multiple: 1,
    },
    render: (amount) => formatCurrency(amount),
    align: "center",
  },
  {
    title: "СТАТУС",
    dataIndex: "paymentStatus",
    sorter: {
      compare: (a, b) => a.paymentStatus - b.paymentStatus,
      multiple: 1,
    },
    render: (paymentStatus) => invoiceStatus(paymentStatus),
    align: "center",
  },
  {
    title: "",
    key: "operation",
    fixed: "right",
    width: 100,
    render: (text, record, index) => (
      <Space size="middle" align="center" key={index}>
        <Link
          to={{
            pathname: `/invoice-desc/${record?._id}`
          }}
        >
          <FileTextOutlined />
        </Link>
        <Link
          to={{
            pathname: `/invoice-print/${record?._id}`,
            
          }}
        >
          <CloudDownloadOutlined />
        </Link>
      </Space>
    ),
    align: "center",
  },
];

const InvoiceList = ({ invoices , tableState, loading = false }) => {
  const {page, pageSize, totalDocs} = tableState
  return <Table columns={columns} dataSource={invoices} rowKey="_id" loading={loading}
   pagination={{
    current: page,
    pageSize: pageSize,
    total : totalDocs,
    showSizeChanger: true,
  }}/>;
};

export default InvoiceList;
